export default {
	'please-select-a-role': 'Por favor seleccione un rol',
	'loading-roles': 'Cargando roles...',
}